module.exports = __webpack_public_path__ + "static/media/pen-white.1e763e8c.svg";